import {useForm} from 'react-hook-form'
import { Client_Event_Name, } from '@quiz-buzz/common'
import {page_header_style, Standard_Page_Layout, sub_header_style} from '../Components/Standard_Page_Layout'
import { style } from 'typestyle'
import { Button, button_input_attach_style, input_button_attached_style } from '../Components/Button'
import { header_over_form_style } from '../App/style/Headers'
import { validation_error_style, validation_warn_style } from '../App/style/Forms'
import { player_machine_actor } from '../App/main'

type FormValues = {
	player_name: string
}

export function Player_Registration() {
	const {
		register,
		handleSubmit,
		formState: {errors},
	} = useForm<FormValues>()

	// TODO: we can probably get this out of the state machine rather than browser API
	let game_code = ''
	if (window.location.hash && window.location.hash.slice(1).length === 4) {
		game_code = window.location.hash.slice(1)
	}

	const onSubmit = handleSubmit(data =>
		player_machine_actor.send({type: Client_Event_Name.register_player, detail: { game_code, ...data }}),
	)
	const cancel_registration = () => {
		window.location.hash = ''
		history.back()
	}
	

	const header = (
		<>
			<div className={page_header_style}>Join</div>
			<div className={sub_header_style}>Join game, code: <span className="highlight_text">{game_code}</span></div>
		</>
	)

	const content = (
		<>
			<div className={header_over_form_style}>
				<div className="h2"><label htmlFor="player_reg_name">Please enter your name</label></div>
			</div>
			<form id="register_player_form" className={register_player_form_style} onSubmit={onSubmit}>
				<input
					id="player_reg_name"
					type="text"
					data-help-tip="intro"
					className={input_button_attached_style + ' ' + (errors.player_name ? validation_warn_style : '')}
					{...register('player_name', {
						required: {
							value: true,
							message: 'you need a name!',
						},
						maxLength: {value: 100, message: 'too long'},
						minLength: {value: 3, message: 'too short'},
					})}
					placeholder="nickname"
				/>
				<button className={button_input_attach_style} type="submit">&gt;</button>
				{errors.player_name ? <div className={validation_error_style}>
					{errors.player_name?.message}
				</div> : ''}
			</form>
		</>
	)

	const controls = (
		<div className='two_buttons'>
			<Button button_style="Danger" text="Cancel" onClick={cancel_registration} />
			<Button button_style="Primary" text="Join game" type="submit" form="register_player_form" />
		</div>
	)

	return (
		<Standard_Page_Layout
			header={header}
			content={content}
			controls={controls}
		/>
	)
}

const register_player_form_style = style({
	margin: '0 auto'
})